<div class="flex flex-col items-center justify-center gap-2">
    <img [src]="'images/404.png' | assetUrl" alt="404" width="500" height="500">
    <div class="flex flex-col  items-center justify-center">
        <h1 class="text-xl font-semibold">{{'Oops! There seems to be a problem' | textCase}}</h1>
        @if (customMessage) {
            <p class="font-medium mt-2 text-red-600">{{ customMessage }}</p>
        } @else {
            <p class="font-medium mt-2">{{'The page you are looking for does not exist or has been moved' | textCase}}</p>
        }
    </div>
    <app-button label="{{'Go Home' | textCase}}" variant="filled" severity="primary" (clicked)="goToLogin()" />
</div>
